import Common from '../Common';
import Department from './contact/Department';
import Favorite from './contact/Favorite';
import Field from './contact/Field';

interface postBody {
	name: string,
	pbx_user_id?: string,
	pbx_contact_favorite?: string
}

const Contact = class extends Common {
	field: InstanceType<typeof Field>
	department: InstanceType<typeof Department>
	favorite: InstanceType<typeof Favorite>

	constructor(headers: ApiHeaders) {
		super(headers)

		this.field = new Field(headers);
		this.department = new Department(headers);
		this.favorite = new Favorite(headers);
	}

	async read(contactId: id) {
		return this.get(`/contact/${contactId}`)
	}

	async update(contactId: id, body: postBody) {
		return this.patch(`/contact/${contactId}`, body)
	}

	async create(body: postBody) {
		return this.post(`/contact`, body)
	}

	async delete(contactId: id) {
		return this.doDelete(`/contact/${contactId}`)
	}
}

export default Contact
